import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import LabeledSheet from 'LuxKit/LabeledSheet'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Sheet from 'components/utils/Sheet'
import LuxPlusLabelContext from 'contexts/LuxPlusLabelContext'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits, getIsLuxPlusLPPEnabled } from 'luxPlus/selectors/featureToggle'
import type { MouseEventHandler } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import LuxPlusLabel from '../../LuxKit/Label/LuxPlusLabel'
import LuxPlusBenefitsModal from './modals/LuxPlusBenefitsModal'

interface Props {
  offerPrice: number
  offerMemberPrice: number
  hasLuxPlusRate?: boolean
  hideUpsellModal?: boolean
  offer: App.BedbankOffer | App.BedbankOfferSummary
}

function LuxLPPPricingLabeledSheet(props: Props) {
  const {
    offerPrice,
    offerMemberPrice,
    hasLuxPlusRate,
    offer,
  } = props
  const luxPlusLPPEnabled = useAppSelector(getIsLuxPlusLPPEnabled)
  const canViewLuxPlusBenefits = useAppSelector(getCanViewLuxPlusBenefits)
  const saveAmount = offerPrice - offerMemberPrice
  const showModal = useContext(ModalContext)
  const providerPage = useContext(LuxPlusLabelContext)

  const toggleModal = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    showModal(<LuxPlusBenefitsModal
      type="member-price-offer-lpp-no-save-amount"
      saveAmount={saveAmount}
      offer={offer}
      providerPage={providerPage}
    />)
  }, [offer, providerPage, saveAmount, showModal])

  const intl = useIntl()

  if (!luxPlusLPPEnabled || !hasLuxPlusRate) return null

  return <LabeledSheet
    kind="lux-plus"
    label={<LuxPlusLabel type="only-logo" />}
  >
    <Sheet padding={8}>
      <BodyTextBlock
        variant="medium"
        weight="bold"
        endIcon={canViewLuxPlusBenefits ? undefined : <Clickable onClick={toggleModal}><LineInfoCircleIcon /></Clickable>}
        fit="auto"
      >
        {intl.formatMessage({
          id: 'OMTMhBD3F54tx1lcYdS4',
          defaultMessage: 'Member savings on select packages',
          description: 'Body text indicating LuxPlus+ member savings on select bedbank packages',
        })}
      </BodyTextBlock>
    </Sheet>
  </LabeledSheet>
}

export default LuxLPPPricingLabeledSheet
